import { i18nMark } from 'lingui-react';

const messages = {
  loggingOut: i18nMark('Logging out...'),
};

export default messages;



// WEBPACK FOOTER //
// ./features/authentication/LogoutPage/messages.js